import { cn } from "../../helpers"
import { paragraph } from "../typography"

const wrapper = cn("items-top flex space-x-2")

const label = (isDisabled?: boolean) =>
  cn("flex cursor-pointer items-center gap-2", isDisabled ? "cursor-not-allowed" : null)

const checkbox = (className?: string) =>
  cn(
    "peer h-5 w-5 shrink-0 rounded-md border-2 border-neutral-300 disabled:border-neutral-400 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-neutral-200 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-none data-[state=checked]:bg-blurple-500 data-[state=checked]:text-white",
    className,
  )

const checboxIndicator = cn("flex items-center justify-center text-current")

const checkIcon = cn("w-4 h-4 text-white")

const checkboxText = cn(paragraph({ size: "sm", className: "peer-disabled:text-neutral-600" }))

export { wrapper, label, checkbox, checboxIndicator, checkIcon, checkboxText }
